'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.errorModalClose = exports.errorModalOpen = undefined;

var _errorModalConstants = require('./errorModalConstants');

var errorModalOpen = exports.errorModalOpen = function errorModalOpen(_ref) {
  var modalId = _ref.modalId,
      data = _ref.data;
  return { type: _errorModalConstants.ERROR_MODAL_OPEN, modalId: modalId, data: data };
}; // Constants
var errorModalClose = exports.errorModalClose = function errorModalClose() {
  return { type: _errorModalConstants.ERROR_MODAL_CLOSE };
};


//////////////////
// WEBPACK FOOTER
// ./src/client/components/error/modals/errorModalActions.js
// module id = 1768
// module chunks = 0